import React, {useState, useEffect} from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import careersActions from "../../store/actions/careers";
import configActions from "../../store/actions/config";
import {useDispatch, useSelector} from "react-redux";
import InputMask from "react-input-mask";
import paymentActions from "../../store/actions/payment";
import axios from "axios";

const recaptchaRef = React.createRef();


const ModalBecomeAgent = () => {
    const configStore = useSelector((store) => store.configStore);
    const careersStore = useSelector((store) => store.careersStore);
    const dispatch = useDispatch();

    const [formError, setFormError] = useState(null);
    const [currentTopic, setCurrentTopic] = useState('');
    const [recaptchaValue, setRecaptchaValue] = useState('');
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    const reg_ex = /^[0-9]*\.?[0-9]*$/;

    const setPhoneValue = (value) => {
        dispatch(configActions.setFormPhone(value));
        dispatch(configActions.setFormPhoneError(''));
    }
    const setEmailValue = (value) => {
        dispatch(configActions.setFormEmail(value));
        dispatch(configActions.setFormEmailError(''));
    }
    const setNameValue = (value) => {
        dispatch(configActions.setFormName(value));
        dispatch(configActions.setFormNameError(''));
    }
    const setAgencyNameValue = (value) => {
        dispatch(configActions.setFormAgencyName(value));
        dispatch(configActions.setFormAgencyNameError(''));
    }    
    const setCityValue = (value) => {
        dispatch(configActions.setFormCity(value));
        dispatch(configActions.setFormCityError(''));
    }    
    const setStreetValue = (value) => {
        dispatch(configActions.setFormStreet(value));
        dispatch(configActions.setFormStreetError(''));
    }
    const setZipValue = (value) => {
        value = value.replace('-','');
        if (value === '' || value.match(reg_ex)){
            value = value.substring(0, 9);
            if (value.length > 5) {
                value = [value.slice(0, 5), '-', value.slice(5)].join('');
            }
            dispatch(configActions.setFormZip(value));
            dispatch(configActions.setFormZipError(''));
        }
    }
    const setCaptcha = () => {
        setRecaptchaValue(recaptchaRef.current.getValue());
    }

    const modalCLose = () => {
        dispatch(configActions.setFormName(''));
        dispatch(configActions.setFormNameError(''));
        dispatch(configActions.setFormCity(''));
        dispatch(configActions.setFormCityError(''));
        dispatch(configActions.setFormStreet(''));
        dispatch(configActions.setFormStreetError(''));
        dispatch(configActions.setFormZip(''));
        dispatch(configActions.setFormZipError(''));
        dispatch(configActions.setFormAgencyName(''));
        dispatch(configActions.setFormAgencyNameError(''));
        dispatch(configActions.setFormEmail(''));
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormPhone(''));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(careersActions.setModalAgentOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    const formSubmit = (event) => {
        event.preventDefault();
        dispatch(configActions.setFormEmailError(''));
        dispatch(configActions.setFormPhoneError(''));
        dispatch(configActions.setFormNameError(''));

        let formValid = true;
        let formErrorList = [];
        setFormError('');

        if (configStore.formEmail.length < 1){
            formValid = false;
            formErrorList.push('form-email');
            dispatch(configActions.setFormEmailError('Enter your email'));
        } else if (!configStore.formEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)){
            formValid = false;
            formErrorList.push('form-email');
            dispatch(configActions.setFormEmailError('Enter correct email'));
        }

        if (configStore.formPhone.length < 1) {
            formValid = false;
            formErrorList.push('form-phone');
            dispatch(configActions.setFormPhoneError('Enter your phone'));
        } else if (configStore.formPhone.toString().slice(-1) === '_') {
            formValid = false;
            formErrorList.push('form-phone');
            dispatch(configActions.setFormPhoneError('Enter correct phone'));
        }

        if (configStore.formName.length < 3) {
            formValid = false;
            formErrorList.push('form-name');
            dispatch(configActions.setFormNameError('Enter your name'));
        }
        if (configStore.formAgencyName.length < 3) {
            formValid = false;
            formErrorList.push('form-agency-name');
            dispatch(configActions.setFormAgencyNameError('Enter agency name'));
        }
        if (configStore.formAgencyName.length >= 3 && configStore.formAgencyName.length < 10) {
            formValid = false;
            formErrorList.push('form-agency-name');
            dispatch(configActions.setFormAgencyNameError('The name cannot be less than 10'));
        }
        if (configStore.formCity.length < 3) {
            formValid = false;
            formErrorList.push('form-city');
            dispatch(configActions.setFormCityError('Enter your city'));
        }        
        if (configStore.formStreet.length < 3) {
            formValid = false;
            formErrorList.push('form-street');
            dispatch(configActions.setFormStreetError('Enter your street'));
        }
        if (configStore.formZip.length < 10 && configStore.formZip.length !== 5) {
            formValid = false;
            formErrorList.push('form-zip');
            dispatch(configActions.setFormZipError('Enter zip code (5-9 characters)'));
        }

        if (formValid) {
            sendForm();
        } else {
            document.getElementById(formErrorList[0]).scrollIntoView({block: "center", behavior: "smooth"});
        }
    }

    useEffect(() => {
        const NAME_FROM_BACK = "contact_form_become_agent_topic";
        
        axios.get(`${process.env.REACT_APP_API_BASE_URI}settings`)
            .then((response) => {
                const topics = response.data['hydra:member'];
                const currentTopic = topics.find((topic) => topic.name === NAME_FROM_BACK);

                setCurrentTopic(currentTopic);
            });
    }, []);

    const sendForm = () => {
        dispatch(configActions.setLoading(true))
        const today = new Date().toJSON();
        const address = configStore.formStreet + ', ' + configStore.formCity + ' TX ' + configStore.formZip;
        const addressURL = new URL('https://maps.google.com');
        addressURL.searchParams.set('q', address.replace(/\s/g, '+'));

        const content = `<ul>
            <li><span>Agency Name</span><span>${configStore.formAgencyName}</span></li>
            <li><span>Address</span><span><a href="${addressURL.href}" rel="nofollow" target="_blank">${address}</a></span></li>
        </ul>`

        const data = {
            "topic": "/api/email_topics/" + currentTopic.value,
            "subject": "Become an Agent",
            "content": content,
            "sentFrom": "Careers Page",
            "contactPreference": 0,
            "name": configStore.formName,
            "phone": configStore.formPhone,
            "email": configStore.formEmail,
            "createdAt": today,
            "updatedAt": today,
        };

        axios.post(`${process.env.REACT_APP_API_BASE_URI}email_histories`, data, { headers })
            .then(response => formResult(response)).catch(err => formError(err));

        const formResult = (response) => {
            dispatch(configActions.setFormPhone(''));
            dispatch(configActions.setFormEmail(''));
            dispatch(configActions.setFormName(''));
            dispatch(configActions.setFormAgencyName(''));
            dispatch(configActions.setFormCity(''));
            dispatch(configActions.setFormStreet(''));
            dispatch(configActions.setFormZip(''));
            window.grecaptcha.reset();
            dispatch(careersActions.setModalAgentOpen(false));
            dispatch(configActions.setModalSuccessOpen(true));
            document.getElementsByTagName('body')[0].classList.add('modal-open');
            dispatch(configActions.setLoading(false))
        }

        const formError = (err) => {
            console.log(err)
            setFormError('An error occurred, please try again later')
            dispatch(configActions.setLoading(false))
        }
    }


    return (
        <div className="modal" id="become-agent-modal">
            <div className="modal-overlay"/>
            <div className="modal-block">
                <button
                    type='button'
                    className='modal-close'
                    onClick={() => {modalCLose()}}
                >
                    <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`} alt="close"/>
                </button>
                <div className="modal-heading-bg">
                    <div className="modal-title">Become an Agent</div>
                    <div className="modal-subtitle">Since our inception in 1901, the RVOS Insurance Group of
                        Companies has believed in the principle of Neighbors Helping Neighbors.
                        We hold that our independent agents make a difference in the
                        lives of their policyholders and are an important, respected resource in their communities.</div>
                </div>
                <div className="modal-content">
                    <ul className="modal-list checkmarks">
                        <li>Do you desire to build long-lasting relationships with your community by servicing the insurance needs of your friends and neighbors?</li>
                        <li>Do you understand the importance of protecting what matters most to them?</li>
                    </ul>
                    <div className="modal-description">If your answer to these questions is yes, consider becoming an authorized agent for our companies.
                        If you are the owner of an independent agency in Texas and are interested in partnering with us, we would love to hear from you.</div>
                    <div className="form-title">Connect</div>
                    <div className="form-subtitle">To get started, please complete the following contact form and we will connect with you.</div>
                    <form onSubmit={(ev) => {formSubmit(ev)}} className="form">
                        <div className={`form-loader ${configStore.isLoading ? 'is-loading' : ''}`}/>
                        <div className={`form-group ${configStore.formNameError.length > 0 ? 'error' : ''}`} id="form-name">
                            <div className="label">First and last name</div>
                            <input
                                placeholder='e.g. Jane Doe'
                                className='form-input'
                                onChange={(ev) => setNameValue(ev.target.value)}
                                onBlur={(ev) => setNameValue(ev.target.value.trim())}
                                value={configStore.formName}
                            />
                            {configStore.formNameError.length > 0 &&
                            <div className="input-error">{configStore.formNameError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formAgencyNameError.length > 0 ? 'error' : ''}`} id="form-agency-name">
                            <div className="label">Agency name</div>
                            <input
                                placeholder='e.g. XYZ Agency'
                                className='form-input'
                                onChange={(ev) => setAgencyNameValue(ev.target.value)}
                                onBlur={(ev) => setAgencyNameValue(ev.target.value.trim())}
                                value={configStore.formAgencyName}
                            />
                            {configStore.formAgencyNameError.length > 0 &&
                                <div className="input-error">{configStore.formAgencyNameError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formEmailError.length > 0 ? 'error' : ''}`} id="form-email">
                            <div className="label">Email address</div>
                            <input
                                placeholder='e.g. mail@company.com'
                                className='form-input'
                                onChange={(ev) => setEmailValue(ev.target.value)}
                                value={configStore.formEmail}
                            />
                            {configStore.formEmailError.length > 0 &&
                            <div className="input-error">{configStore.formEmailError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formPhoneError.length > 0 ? 'error' : ''}`} id="form-phone">
                            <div className="label">Your phone number</div>
                            <InputMask
                                mask="(999) 999-9999"
                                className='form-input'
                                placeholder='(555) 555-5555'
                                onChange={(ev) => setPhoneValue(ev.target.value)}
                                value={configStore.formPhone}
                            />
                            {configStore.formPhoneError.length > 0 &&
                            <div className="input-error">{configStore.formPhoneError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formCityError.length > 0 ? 'error' : ''}`} id="form-city">
                            <div className="label">City</div>
                            <input
                                placeholder='Miami'
                                className='form-input'
                                onChange={(ev) => setCityValue(ev.target.value)}
                                value={configStore.formCity}
                            />
                            {configStore.formCityError.length > 0 &&
                            <div className="input-error">{configStore.formCityError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formStreetError.length > 0 ? 'error' : ''}`} id="form-street">
                            <div className="label">Street</div>
                            <input
                                placeholder='100-198 NE 4th St'
                                className='form-input'
                                onChange={(ev) => setStreetValue(ev.target.value)}
                                value={configStore.formStreet}
                            />
                            {configStore.formStreetError.length > 0 &&
                            <div className="input-error">{configStore.formStreetError}</div>
                            }
                        </div>
                        <div className={`form-group ${configStore.formZipError.length > 0 ? 'error' : ''}`} id="form-zip">
                            <div className="label">Zip code</div>
                            <input
                                placeholder='e.g. 73301'
                                className='form-input'
                                onChange={(ev) => setZipValue(ev.target.value)}
                                value={configStore.formZip}
                            />
                            {configStore.formZipError.length > 0 &&
                            <div className="input-error">{configStore.formZipError}</div>
                            }
                        </div>
                        <div className="form-captcha">
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size="normal"
                                sitekey="6Ldn930UAAAAACn_tkcxOq1t7Ku9j24GuSrgwbTL"
                                onChange={() => {setCaptcha()}}
                            />
                        </div>
                        <button type='submit' className={`form-submit button-gradient ${recaptchaValue.length < 1 ? 'disabled' : ''}`} >Send</button>
                        <div className="form-error">{formError}</div>
                    </form>
                </div>
            </div>
        </div>
    );
}


export default ModalBecomeAgent;
